import $ from 'jquery';
import validate from "jquery-validation";

$(function () {
	$('.js-phone').keypress(function(e){
		var charCode = (e.which) ? e.keyCode : e.keyCode;
		if ([48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43].indexOf(charCode) === -1) {
			return false;
		}
	});
//validate form
	let scrollPosition;

	let form = $('.js-form'),
		url = form.attr('action')

	form.each(function(){
		let thisForm = $(this);
		thisForm.validate({
			focusInvalid: false,
			errorElement: "label",
			errorPlacement: function(error, element) {
				error.appendTo(element.closest(".js-form-item"));
			},
			/*highlight: function(element) {
                $(element).closest(".js-form-item").addClass('is-error');
            },
              unhighlight: function(element) {
                $(element).closest(".js-form-item").removeClass('is-error');
            },*/
			submitHandler: function(form, event){
				event.preventDefault();
				thisForm.find('.js-submit').addClass('is-active');
				var data = new FormData(),
					formParams = thisForm.serializeArray();

				/*$.each(thisForm.find('.js-input-file'), function(i, tag) {
                  $.each($(tag)[0].files, function(i, file) {
                    data.append(tag.name, file);
                  });
                });*/

				$.each(formParams, function(i, val) {
					data.append(val.name, val.value);
				});

				data.append('key', 'value');

				/* это нужно будет вывеcти после успешной отправки формы, это здесь только для демонстарации выхода попапа */
				//$('.js-thank').addClass('is-show');
				let $submit = thisForm.find('.js-submit');
				let target = $submit.attr('data-link');
				$('.js-popup').removeClass('is-show');
				$('.js-popup[data-block="'+target+'"]').addClass('is-show');
				scrollPosition = $(window).scrollTop();

				var callback = thisForm.attr('data-action-callback');

				if (typeof callback !== 'undefined') {
					window[callback]();
					return false;
				} else {
					/* ******* */
					$.ajax({
						url: thisForm[0].action,
						type: 'POST',
						processData: false,
						contentType: false,
						data: data,
						beforeSend: function (data) {
							thisForm.find('button').attr('disabled', 'disabled');
						},
						success: function (data) {
							if (data['error']) {
								console.log('error');
							} else {
								setTimeout(function () {
									thisForm.find('.js-submit').removeClass('active');
									thisForm.find('button').prop('disabled', false);
									thisForm[0].reset();
									$('.js-thank').addClass('is-show');
								}, 500);
							}
						},
						error: function (xhr, ajaxOptions, thrownError) {
							console.log(xhr.status);
							console.log(thrownError);
						}
					});
				}

				return false;
			}
		});

	})

});

